import cSvg from '#themes/default/default/components/svg/svg.js';

import template from './header.html' with { type: 'html' };

export default {
	name: 'CHeader',
	components: {
		cSvg
	},
	props: {
		ariaDescribeId: {
			type: String,
			default: null
		},
		description: {
			type: String,
			default: null
		},
		hasBiggerPadding: {
			type: Boolean,
			default: false
		},
		headline: {
			type: String,
			default: ''
		},
		icon: {
			type: String,
			default: null
		},
		isCenterAligned: {
			type: Boolean,
			default: false
		},
		subHeadline: {
			type: String,
			default: null
		}
	},
	template
};
